import React, { useEffect, useState } from 'react'
import TitleSection from '../TitleSection/TitleSection'
import { Clickable } from 'chemistry'
import ItemsBuyList from '../ItemsBuyList/ItemsBuyList'
import ActionButtons from '../ActionButtons/ActionButtons'
import CategoryDrawer from '../CategoryDrawer/CategoryDrawer'
import classNames from 'classnames'

const MATERIALS = 'materials'
const TOOLS = 'tools'
export const View = props => {
  const { materials, tools, loadProducts, clearProducts, data, format, lang, contentfulTranslations, fileAttachment } =
    props
  const [currentTab, setCurrentTab] = useState(MATERIALS)
  const [isOpen, setIsOpen] = useState(false)

  const onOpenCategory = category => {
    setIsOpen(true)
    loadProducts(category)
  }

  useEffect(() => {
    if (!isOpen) {
      clearProducts()
    }
    // eslint-disable-next-line
  }, [isOpen])

  return (
    <div className='buy-list-view'>
      <TitleSection contentfulTranslations={contentfulTranslations} fileAttachment={fileAttachment} />
      <div className='tab-switcher hide-desktop hide-on-print'>
        <Clickable
          code='tools' // check if needed in chemistry
          entries={[MATERIALS, TOOLS].map(code => ({
            code,
            product: { url: code, code },
            name: contentfulTranslations[code]
          }))}
          current={currentTab}
          onClick={tab => setCurrentTab(tab)}
        />
      </div>
      <div
        className={classNames(
          'flex gap-32 justify-between lists-wrapper',
          currentTab === MATERIALS ? 'left-list' : 'right-list'
        )}
      >
        <ItemsBuyList
          isActive={currentTab === MATERIALS}
          items={materials?.items}
          title={contentfulTranslations.materials}
          onOpenCategory={onOpenCategory}
          prop='supply'
          type='HowToSupply'
        />
        <ItemsBuyList
          isActive={currentTab === TOOLS}
          items={tools?.items}
          title={contentfulTranslations.tools}
          onOpenCategory={onOpenCategory}
          prop='tool'
          type='HowToTool'
        />
      </div>
      <div className='hide-desktop mt-32 flex justify-start hide-on-print'>
        <ActionButtons contentfulTranslations={contentfulTranslations} fileAttachment={fileAttachment} />
      </div>
      <CategoryDrawer
        format={format}
        lang={lang}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        data={data}
        contentfulTranslations={contentfulTranslations}
      />
    </div>
  )
}
